import { LngLat } from 'maplibre-gl';

import type { Coordinates } from './types';

export const makeLngLat = (coordinates?: Coordinates): LngLat | undefined => {
  if (!coordinates) {
    return undefined;
  }
  return new LngLat(coordinates.longitude, coordinates.latitude);
};

export const roundCoordinates = (coordinates: Coordinates): Coordinates => {
  return {
    latitude: Number(coordinates.latitude.toFixed(5)),
    longitude: Number(coordinates.longitude.toFixed(5)),
  };
};
